"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Detail = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
const useMediaQuery_1 = __importDefault(require("@material-ui/core/useMediaQuery"));
const evidence_defaults_context_1 = require("../evidence-defaults/evidence-defaults-context");
const form_panel_1 = require("../form/fields/form-panel");
const form_1 = require("../form/form");
const prompt_provider_1 = require("../prompt/prompt-provider");
const empty_component_1 = require("../../utils/empty-component");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const detail_context_1 = require("./detail-context");
const detail_hook_1 = require("./detail-hook");
const detail_styles_1 = require("./detail-styles");
const detail_types_1 = require("./detail-types");
// eslint-disable-next-line react/display-name
exports.Detail = (0, react_1.memo)((0, react_1.forwardRef)(function Detail(options, ref) {
    const { props, context, formRef, detailContainerRef, editing, exportDialogRef, } = (0, detail_hook_1.useDetail)(options, ref);
    const { ToolbarComponent, ContainerComponent: ProvidedContainerComponent, EmptyContainerComponent: ProvidedEmptyContainerComponent, FieldsComponent, GeneralFieldsComponent, ExportDialogComponent, toolbarProps, validationSchema, } = props;
    const provideData = (0, event_callback_hook_1.useEventCallback)(() => {
        var _a, _b;
        return ({
            id: (_b = (_a = options.source.data) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '',
        });
    });
    const { enableEmptyDetailContainer } = (0, react_1.useContext)(evidence_defaults_context_1.EvidenceDefaultsContext);
    const ContainerComponent = enableEmptyDetailContainer && context.mode === detail_types_1.DetailMode.NONE
        ? ProvidedEmptyContainerComponent
        : ProvidedContainerComponent;
    const classes = (0, detail_styles_1.useStyles)();
    const isSmall = (0, useMediaQuery_1.default)('(max-width:960px)');
    return (react_1.default.createElement("div", { className: classes.outerWrapper, "data-cy": "EAS__DETAIL", style: {
            minWidth: !isSmall ? '700px' : 'auto',
        } },
        react_1.default.createElement(detail_context_1.DetailContext.Provider, { value: context },
            react_1.default.createElement(prompt_provider_1.PromptProvider, null,
                options.source.loading && (react_1.default.createElement("div", { "data-cy": "EAS__DETAIL_LOADER", className: classes.loaderWrapper },
                    react_1.default.createElement(CircularProgress_1.default, { disableShrink: true, className: classes.loader }))),
                react_1.default.createElement(ToolbarComponent, { ...toolbarProps }),
                react_1.default.createElement("div", { ref: detailContainerRef, className: classes.wrapper },
                    react_1.default.createElement(form_1.Form, { ref: formRef, initialValues: {}, onSubmit: context.save, editing: editing, validationSchema: validationSchema },
                        react_1.default.createElement(ContainerComponent, null,
                            react_1.default.createElement(FieldsComponent, null),
                            !(GeneralFieldsComponent === empty_component_1.EmptyComponent ||
                                GeneralFieldsComponent === undefined) && (react_1.default.createElement(form_panel_1.FormPanel, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_DETAIL_TITLE", defaultMessage: "Obecn\u00E9" }) },
                                react_1.default.createElement(GeneralFieldsComponent, null)))))),
                props.reportTag !== null && (react_1.default.createElement(ExportDialogComponent, { ref: exportDialogRef, tag: props.reportTag, provideData: provideData }))))));
}));
//# sourceMappingURL=detail.js.map